import { TrendingDown } from "lucide-react";
import { LucideProps } from "lucide-react";

interface TradeIconProps extends LucideProps {
  className?: string;
}

export default function TradeIcon({ className = "", size = 24, ...props }: TradeIconProps) {
  return <TrendingDown className={className} size={size} {...props} />;
}
